/* eslint-disable no-console */
/* eslint-disable no-undef */
import {
  WrapModal,
  WrapClassTable,
  FormButtonCancel,
  FormButtonSave,
  StyledEditAttributes,
} from './styles';

import PaletteColor from './components/PaletteColor';

import colorsScale from '../../services/colorsScale.json';

import Icon from '@map/components/Icons';
import { TextField } from '@material-ui/core';
import CircularProgress from '@material-ui/core/CircularProgress';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import SelectMui from '@material-ui/core/Select';
import Tooltip from 'components/Tooltip';
import { useEffect, useState } from 'react';

export const EditSymbology = ({
  layer,
  modalEditSymbology,
  setModalEditSymbology,
  onClose,
}) => {
  // Estado para armazenar o índice da linha que está sendo "hovered"
  const [hoveredRow, setHoveredRow] = useState(null);
  const [columnsList, setColumnsList] = useState([]);
  const [classColumn, setClassColumn] = useState(null);
  const [originalClassColumn, setOriginalClassColumn] = useState(null);
  const [colorScale, setColorScale] = useState(null);
  const [originalColorScale, setOriginalColorScale] = useState(null);
  const [classList, setClassList] = useState([]);
  const [originalClassList, setOriginalClassList] = useState([]);
  const [loadingClassification, setLoadingClassification] = useState(false);
  const [loadingApplyClassification, setLoadingApplyClassification] =
    useState(false);
  const [disableSubmitSimbologyForm, setDisableSubmitSimbologyForm] =
    useState(true);
  const [selectedFeature, setSelectedFeature] = useState(null);
  const [changedClassList, setChangedClassList] = useState(false);
  const [color, setColor] = useState('#000000');
  const [anchorElColor, setAnchorElColor] = useState(null);
  const [anchorElPalleteColor, setAnchorElPalleteColor] = useState(false);
  const [disableNickname, setDisableNickname] = useState(true);

  /**
   * Obtém colunas da camada para classificação
   */
  useEffect(() => {
    if (modalEditSymbology) {
      setColumnsList(layer.getColumns());
    }
  }, [modalEditSymbology, layer]);

  /**
   * Constroi classificação
   */
  useEffect(() => {
    /**
     * Prepara formulário para listar classificações
     */
    const listClassifications = async () => {
      if (
        classColumn === originalClassColumn &&
        colorScale === originalColorScale &&
        !changedClassList
      ) {
        setClassList(originalClassList);
      } else {
        let generatedClassList = await layer.generateClassList(
          classColumn.value,
          colorScale.value
        );
        setClassList(generatedClassList);

        setChangedClassList(true);
      }
      await sleep(250);
      setLoadingClassification(false);
      setDisableSubmitSimbologyForm(false);
    };

    if (classColumn && colorScale) {
      setLoadingClassification(true);
      listClassifications();
    }
  }, [
    classColumn,
    colorScale,
    layer,
    originalClassColumn,
    originalColorScale,
    originalClassList,
    changedClassList,
  ]);

  const sleep = (ms) => {
    return new Promise((r) => setTimeout(r, ms));
  };

  /**
   * Submit do formulário de simbologia
   */
  const handleSubmitSimbologyForm = async () => {    
    setLoadingApplyClassification(true);
    layer.setClassColumn(classColumn.value);
    layer.setColorScale(colorScale.value);
    layer.setClassList(classList);
    layer.applyFeaturesStyle();
    await sleep(250);
    setLoadingApplyClassification(false);
    setModalEditSymbology(!modalEditSymbology);
    onClose && onClose();
  };

  const openColor = (event) => {
    setAnchorElColor(event.currentTarget);
  };

  const handleCloseColor = () => {
    setAnchorElColor(null);
    setAnchorElPalleteColor(false);
  };

  const handleConfirmColor = (e) => {
    setAnchorElColor(null);
    setColor(e);
    editSymbologyFeature(e);
  };

  /**
   * Persiste cor selecionada da ediçao de simbologia individual
   *
   * @param {string} paramColor
   */
  const editSymbologyFeature = (paramColor) => {
    let changedClassList = structuredClone(classList); // clone classList
    changedClassList.map((b, i) => {
      if (selectedFeature === b.value) {
        changedClassList[i].simbology.fillColor = paramColor; // change color
      }
      return null;
    });
    setClassList(changedClassList);
  };

  useEffect(() => {
    if (layer.classColumn && layer.colorScale) {
      layer.getColumns().map((b) => {
        if (layer.classColumn === b.label) {
          setClassColumn(b);
          setOriginalClassColumn(b);
        }
        return null;
      });
      colorsScale.map((b) => {
        if (layer.colorScale === b.value) {
          setColorScale(b);
          setOriginalColorScale(b);
        }
        return null;
      });
      let oClassList = [...layer.classList];
      setOriginalClassList(oClassList);
    }
  }, [layer]);

  useEffect(() => {
    function handleClickOutside(event) {
      if (
        disableNickname !== null &&
        !event.target.closest('.containerTextField')
      ) {
        setDisableNickname(true); // Finaliza a edição ao clicar fora
      }
    }

    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [disableNickname]);

  return (
    <WrapModal>
      <div className="divGeral">
        <div className="titleLayer">{layer.alias}</div>
        {loadingApplyClassification && (
          <div className="loadingApplyClassification">
            <CircularProgress color="inherit" />
          </div>
        )}
        <div className="flex-row-label">Coluna</div>
        <div className="flex-row">
          <div style={{ width: 170 }}>
            <FormControl variant="outlined" margin="dense" fullWidth>
              <InputLabel id="class-column" shrink={false}>
                {!classColumn ? '-- Selecione --' : classColumn.label}
              </InputLabel>
              <SelectMui
                labelId="class-column"
                value={null}
                onChange={(e) => {
                  setClassColumn(e.target.value);
                }}
                MenuProps={{ style: { zIndex: 2000 } }}
                IconComponent={(props) => (
                  <Icon
                    i="map-chevrondown"
                    style={{ top: 'auto', right: 12 }}
                    {...props}
                  />
                )}
              >
                {columnsList.map((s, i) => (
                  <MenuItem value={s} key={i}>
                    {s.label}
                  </MenuItem>
                ))}
              </SelectMui>
            </FormControl>
          </div>
        </div>
        <div className="flex-row-label">Escala de cores</div>
        <div className="flex-row">
          <div style={{ width: 215 }}>
            <FormControl variant="outlined" margin="dense" fullWidth>
              {!colorScale && (
                <InputLabel id="color-scale" shrink={false}>
                  -- Selecione --
                </InputLabel>
              )}
              <SelectMui
                labelId="color-scale"
                value={colorScale}
                onChange={(e) => {
                  setColorScale(e.target.value);
                }}
                MenuProps={{ style: { zIndex: 2000 } }}
                IconComponent={(props) => (
                  <Icon
                    i="map-chevrondown"
                    style={{ top: 'auto', right: 12 }}
                    {...props}
                  />
                )}
              >
                {colorsScale.map((s, i) => (
                  <MenuItem value={s} key={i}>
                    <Icon i={s.label} />
                  </MenuItem>
                ))}
              </SelectMui>
            </FormControl>
          </div>
        </div>
        <div className="flex-row-label">Classes</div>
        <div className="flex-row">
          <div className="area-table">
            {loadingClassification && (
              <div className="loaderClassification">
                <CircularProgress color="inherit" />
              </div>
            )}
            <WrapClassTable>
              <table>
                <tr>
                  <th>Classificação</th>
                  <th>Atributo</th>
                </tr>
                {classList.map((classRow, iClassRow) => {
                  return (
                    <tr key={iClassRow}>
                      <td>
                        <button
                          className="buttonEditSymbology"
                          onClick={(e) => {
                            e.preventDefault();
                            openColor(e);
                            setColor(classRow.simbology.fillColor);
                            setSelectedFeature(classRow.value);
                            setAnchorElPalleteColor(true);
                          }}
                        >
                          {layer.getClassificationIcon(
                            classRow.simbology.fillColor
                          )}
                          <div className="iconBucket">
                            <Icon i="map-editsymbology-bucket" />
                          </div>
                        </button>
                      </td>

                      <td
                        style={{ verticalAlign: 'top' }}
                        onClick={() => setDisableNickname(iClassRow)}
                        onMouseEnter={() => setHoveredRow(iClassRow)} // Define a linha como "hovered"
                        onMouseLeave={() => setHoveredRow(null)} // Reseta a linha quando o mouse sai
                      >
                        <Tooltip
                          title="Inserir ou editar apelido da legenda"
                          placement="bottom"
                        >
                          <StyledEditAttributes>
                            <div
                              style={{
                                display: 'flex',
                                alignItems: 'center',
                              }}
                            >
                              {/* Texto da legenda */}
                              <span>
                                {classRow.value}{' '}
                                {classList[iClassRow].nickname ? '- ' : ''}
                                {disableNickname === iClassRow ? (
                                  <div className="containerTextField">
                                    <TextField
                                      type="text"
                                      value={classList[iClassRow].nickname}
                                      onChange={(e) => {
                                        const newList = [...classList];
                                        newList[iClassRow] = {
                                          ...newList[iClassRow],
                                          nickname: e.target.value,
                                        };
                                        setClassList(newList);
                                      }}
                                      placeholder="Apelido"
                                      variant="standard"
                                      size="small"
                                      inputProps={{
                                        style: {
                                          fontSize: '0.8rem',
                                          marginBottom: '1px solid ',
                                          marginTop: '-4px',
                                        },
                                      }}
                                      autoFocus
                                    />
                                  </div>
                                ) : (
                                  <span style={{ marginLeft: '3px' }}>
                                    {classRow.nickname &&
                                      `(${classRow.nickname})`}
                                  </span>
                                )}
                              </span>

                              {/* Ícone com espaçamento fixo */}
                              <span
                                style={{
                                  marginLeft: '10px',
                                  width: '20px', // Largura fixa para o ícone
                                  visibility:
                                    hoveredRow === iClassRow &&
                                    disableNickname !== iClassRow
                                      ? 'visible'
                                      : 'hidden',
                                  transition: 'visibility 0.2s',
                                }}
                              >
                                <Icon
                                  i="map-editSymbology"
                                  fill={`${
                                    (layer.type === 'importada' ||
                                      layer.type === 'criada' ||
                                      ((layer.type === 'interna' ||
                                        layer.type === 'externa') &&
                                        layer.additionalProps?.service ===
                                          'WFS')) &&
                                    layer.dataType !== 'Text'
                                      ? ''
                                      : '#b6b6b6'
                                  }`}
                                />
                              </span>
                            </div>
                          </StyledEditAttributes>
                        </Tooltip>
                      </td>
                    </tr>
                  );
                })}
              </table>
            </WrapClassTable>
          </div>
        </div>

        <div className="divButtons">
          <FormButtonCancel
            color="primary"
            onClick={() => {
              setClassColumn(originalClassColumn);
              setColorScale(originalColorScale);
              setModalEditSymbology(!modalEditSymbology);
            }}
          >
            Cancelar
          </FormButtonCancel>
          <FormButtonSave
            color="primary"
            disabled={disableSubmitSimbologyForm}
            onClick={() => {
              handleSubmitSimbologyForm();
            }}
          >
            Salvar
          </FormButtonSave>
        </div>
      </div>
      {anchorElPalleteColor && (
        <PaletteColor
          paramColor={color}
          anchorElColor={anchorElColor}
          handleConfirmColor={handleConfirmColor}
          handleCloseColor={handleCloseColor}
        />
      )}
    </WrapModal>
  );
};
